const ROUTES = [
  {
    id: "threads",
    match: /^\/(?:threads)?\/?$/,
    parse() {
      return {};
    }
  },
  {
    id: "thread-detail",
    match: /^\/threads\/([^/]+)\/?$/,
    parse(match) {
      return { threadID: decodeURIComponent(match[1]) };
    }
  },
  {
    id: "turns",
    match: /^\/(?:turns|runs)?\/?$/,
    parse() {
      return {};
    }
  },
  {
    id: "turn-detail",
    match: /^\/(?:turns|runs)\/([^/]+)\/?$/,
    parse(match) {
      return { turnID: decodeURIComponent(match[1]) };
    }
  },
  {
    id: "agents",
    match: /^\/agents\/?$/,
    parse() {
      return {};
    }
  },
  {
    id: "models",
    match: /^\/models\/?$/,
    parse() {
      return {};
    }
  },
  {
    id: "workspaces",
    match: /^\/workspaces\/?$/,
    parse() {
      return {};
    }
  }
];

export function createRouter(onChange) {
  const handlePopState = () => {
    onChange(resolveRoute(window.location.pathname));
  };
  window.addEventListener("popstate", handlePopState);

  return {
    current() {
      return resolveRoute(window.location.pathname);
    },
    start() {
      const route = resolveRoute(window.location.pathname);
      if (route.pathname !== window.location.pathname) {
        window.history.replaceState({}, "", route.pathname);
      }
      onChange(route);
    },
    navigate(pathname, options = {}) {
      const normalized = normalizePath(pathname);
      if (normalized === window.location.pathname) {
        onChange(resolveRoute(normalized));
        return;
      }
      if (options.replace) {
        window.history.replaceState({}, "", normalized);
      } else {
        window.history.pushState({}, "", normalized);
      }
      onChange(resolveRoute(normalized));
    },
    dispose() {
      window.removeEventListener("popstate", handlePopState);
    }
  };
}

export function resolveRoute(pathname) {
  const normalized = normalizePath(pathname);
  for (const route of ROUTES) {
    const match = normalized.match(route.match);
    if (!match) {
      continue;
    }
    return {
      id: route.id,
      pathname: normalized,
      params: route.parse(match)
    };
  }
  return {
    id: "threads",
    pathname: "/threads",
    params: {}
  };
}

function normalizePath(pathname) {
  const raw = String(pathname || "").trim() || "/";
  let normalized = raw.startsWith("/") ? raw : `/${raw}`;
  if (normalized === "/") {
    return "/threads";
  }
  normalized = normalized.replace(/^\/sessions(\/|$)/, "/threads$1");
  normalized = normalized.replace(/^\/runs(\/|$)/, "/turns$1");
  normalized = normalized.replace(/^\/llm(\/|$)/, "/models$1");
  return normalized.replace(/\/+$/, "") || "/";
}
